import $ from "jquery";
import swal from "sweetalert";
import Turbolinks from "turbolinks";
// import dingUrl from "./dingdingding.mp3";
import "./index.css";

const compliments = [
  "We appreciate you!",
  "You're an awesome salesperson!",
  "You deserve a hug right now!",
  "You should be proud of yourself. Really!",
  "On a scale from 1 to 10, you're an 11!",
  "You're wonderful!",
  "You're better than a triple-scoop ice cream cone. With sprinkles!",
  "You're one of a kind!",
  "You're inspiring!",
  "You should be thanked more often. So thank you!!",
  "Attendees are going to love that event so much more now, thanks to you.",
  "Who raised you? They deserve a medal for a job well done.",
  "Your sales potential seems limitless. Rock on!",
  "Actions speak louder than words, and yours tell an incredible story.",
  "When you make up your mind about something, nothing stands in your way.",
  "Any team would be lucky to have you on it. Our team, especially so. Thank you!",
  "In high school I bet you were voted 'most likely to keep being awesome.'",
  "There's ordinary salespeople, and then there's you!",
  "Those attendees are going to have a great time and, thanks to you, will have photos to remember this event forever. You are making a difference in their lives!",
  "You're a gift to this company. Thank you!"
];

$(document).on("click", "[data-behavior~=verbal-close]", event => {
  const continueUrl = $(event.target).data("continueUrl");
  // const audio = new Audio(dingUrl);
  // audio.play();

  const compliment =
    compliments[Math.floor(Math.random() * compliments.length)];
  swal({
    className: "swal-verbal-close",
    title: "Good job!",
    text: `Congrats on getting a verbal close. ${compliment}`,
    icon: "success",
    buttons: {
      confirm: {
        text: "Confirm Verbal Close"
      },
      cancel: true
    }
  }).then(value => {
    if (value) {
      Turbolinks.visit(continueUrl);
    }
  });
});
